import { Heading } from '@lmc/ui-kit'
import styled from 'styled-components'
import { ComponentProps, FC } from 'react'

const StyledHeading = styled(Heading)`
  color: ${({ theme }) => theme.palette.darkpurple};
  font-weight: 700;
  font-size: 54px;
  max-width: 800px;
  font-family: gilroy;
  line-height: 59px;
`

export const OnboardingHeading: FC<ComponentProps<typeof Heading>> = (props) => (
  <StyledHeading {...props} />
)
